import request from '../nasm_sdk_v2/request';

export default function fitnessComponents(apiVer) {
  function getList(apiVersion = apiVer) {
    return request.get(`${apiVersion}/api/fitness-components`);
  }

  return { getList };
}